import { css } from '@/styled-system/css';

export const container = css({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

export const menu = css({
  position: 'absolute',
  top: 'calc(100% + 8px)',
  right: 0,
  zIndex: 'zIndexOverlay',
  display: 'flex',
  flexDirection: 'column',
  minWidth: '176px',
  m: 0,
  p: '1x',
  listStyle: 'none',
  bg: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
});

export const menuItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  width: '100%',
  px: '2x',
  py: '1x',
  bg: 'transparent',
  border: 'none',
  borderRadius: '4px',
  color: 'hpxBlue600',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 'sm',
  lineHeight: 'sm',
  textAlign: 'left',
  whiteSpace: 'nowrap',

  _hover: {
    bg: 'hpxGrey100',
  },

  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const menuItemIcon = css({
  color: 'hpxBlue600',
  flexShrink: 0,
});
